<!--
 * @Description: 站点地图
 * @Author: F-Stone
 * @LastEditTime: 2025-08-14 18:16:24
-->

<template>
  <div>
    <div :class="$style['m-site-map']">
      <div :class="[$style['m-container'],$style['sitemap-width']]">
        <div :class="$style['m-container--inner']">
          <div :class="$style['social-contact']" class="flex justify-between items-center">
            <div :class="$style['state--pos-left']">
              <div :class="$style['nav-logo']" class="flex items-center">
                <UtilSiteLogo :isPureColor="true"/>
              </div>
            </div>
            <div :class="$style['state--pos-right']">
              <div :class="$style['social-group']" class="grid grid-flow-col-dense">
                <div v-for="(item, index) in socialContactList" :key="index" :class="$style['social-item']">
                  <a v-if="item.sub.length < 2 && item.sub.length" :class="$style['item-inner']"
                     class="flex justify-center items-center" :href="item.sub[0].url" target="_blank">
                    <UeIcon :name="item.icon"/>
                  </a>
                  <button v-if="item.sub.length > 1" :class="$style['item-inner']"
                          class="flex justify-center items-center">
                    <UeIcon :name="item.icon"/>
                  </button>
                  <div v-if="item.sub.length > 1">
                    <div v-if="item.sub" :class="$style['group--sub']">
                      <div :class="$style['group--sub-inner']" class="grid grid-cols-2">
                        <a v-for="(subItem, subIndex ) in item.sub" :key="subIndex" target="_blank" :href="subItem.url" :class="$style['sub-item']">
                          <span :class="$style['text']">{{subItem.title }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="$style['site-map']" class="flex justify-between">
            <div v-for="(item, index) in siteMapList" :key="index" :class="$style['col-group']">
              <div :class="$style['group-title']">
                <span class="text">{{ $t(item.title) }}</span>
              </div>
              <div :class="$style['group-body']">
                <div :class="$style['sub-group']" class="grid">
                  <p v-for="(subItem, subIndex) in item.sub" :key="subIndex">
                    <a v-if="subItem.link" target="_blank" :href="subItem.link"
                       :class="$style['sub-item']">
                      <span :class="$style['text']">{{subItem.title }}</span>
                    </a>
                    <a v-else :class="$style['sub-item']" :href="subItem.url"> <span :class="$style['text']" @click="$router.push(subItem.url)">{{subItem.title}}</span></a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SiteFoot @showLocalSwitchPanel="showLocalSwitchPanel = true"/>
    <Transition :css="false" @enter="enter" @leave="leave">
      <SiteLocalSwitchPanel
          v-if="showLocalSwitchPanel"
          ref="localSwitchPanel"
          @close="showLocalSwitchPanel = false"
      />
    </Transition>
  </div>
</template>
<script>
import UtilSiteLogo from '@/components/util/SiteLogo.vue'
import {linksApi} from "@/apis/resource";
import {mapGetters} from 'vuex'
import SiteFoot from '@/components/layout/SiteFoot'
import SiteLocalSwitchPanel from "@/components/layout/SiteLocalSwitchPanel.vue";
import urls from "@/utils/baseUrl";

export default {
  name: 'SiteMap',
  components: {UtilSiteLogo, SiteFoot, SiteLocalSwitchPanel},
  data() {
    return {
      // 如需站点地图与社交数据，请在此填充或从接口获取
      socialContactList: [
        {
          icon: "telegram",
          title: "telegram",
          type: "telegram",
          sub: [],
        },
        {
          icon: "twitter",
          title: "twitter",
          type: "twitter",
          sub: [],
        },
        {
          icon: "ins",
          title: "ins",
          type: "ins",
          link: "",
          sub: []
        },
        {
          icon: "medium",
          title: "medium",
          type: "medium",
          link: "",
          sub: []
        },
        {
          icon: "discord",
          title: "discord",
          type: "discord",
          link: "",
          sub: []
        },
        {
          icon: "youtube",
          title: "youtube",
          type: "youtube",
          link: "",
          sub: []
        },
        {
          icon: "facebook",
          title: "facebook",
          type: "facebook",
          link: "",
          sub: []
        },
        {
          icon: "cmc",
          title: "cmc",
          type: "cmc",
          link: "",
          sub: []
        },
      ],
      showSubGroup: '',
      showLocalSwitchPanel: false,
    }
  },
  computed: {
    ...mapGetters(['currency', 'languageName', 'language', 'token', 'isDirection']),
    siteMapList() {
      return [
        {
          title: this.$t('400037'),
          sub: [
            {
              title: this.$t('400038'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/articles/4413122414105' : this.language == 'ko' ? 'https://support.superex.com/hc/en-001/articles/11479008598553' : 'https://support.superex.com/hc/en-001/articles/11479008598553',
              url: ""
            },
            {
              title: this.$t('400039'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/articles/11461213305625' : this.language == 'ko' ? 'https://support.superex.com/hc/en-001/articles/11478863478809' : 'https://support.superex.com/hc/en-001/articles/11478863478809',
              url: ""
            },
            {
              title: this.$t('400040'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410470420249' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410470420249' : 'https://support.superex.com/hc/en-001/categories/4410470420249',
              url: ""
            },
            {
              title: this.$t('8100015'), //媒体工具包 8100015
              link: '',
              url: `${urls.linkUrl}/mediaMaterial`
            },
          ],
        },
        {
          title: this.$t('400004'),
          sub: [
            {
              title: this.$t('400042'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4412787796889-%E6%96%B0%E6%89%8B%E4%B8%AD%E5%BF%83' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4412787796889-%EC%B4%88%EB%B3%B4%EC%9E%90-%EC%95%84%EC%B9%B4%EB%8D%B0%EB%AF%B8' : 'https://support.superex.com/hc/en-001/categories/4412787796889-Beginner-s-Center',
              url: ""
            },
            {
              title: this.$t('400043'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410478890137-%E7%8F%BE%E8%B2%A8-%E6%9D%A0%E6%9D%86%E4%BA%A4%E6%98%93' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410478890137-%ED%98%84%EB%AC%BC-%EB%A0%88%EB%B2%84%EB%A6%AC%EC%A7%80-%EA%B1%B0%EB%9E%98' : 'https://support.superex.com/hc/en-001/categories/4410478890137-Spot-Leveraged-Trading',
              url: ""
            },
            {
              title: this.$t('400044'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410478992793-%E5%90%88%E7%B4%84%E4%BA%A4%E6%98%93' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410478992793-%EC%84%A0%EB%AC%BC-%EA%B1%B0%EB%9E%98' : 'https://support.superex.com/hc/en-001/categories/4410478992793-Futures-Trading',
              url: ""
            },
            {
              title: this.$t('400045'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4412774906905-%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4412774906905-FAQ' : 'https://support.superex.com/hc/en-001/categories/4412774906905-FAQ',
              url: ""
            },
          ],
        },
        {
          title: this.$t('400046'),
          sub: [
            {
              title: this.$t('400047'),
              link: "",
              url: `${urls.linkUrl}/userCenter/fee/trading`
            },
            {
              title: this.$t('400048'),
              link: "",
              url: `${urls.linkUrl}/rule`
            },
            {
              title: this.$t('400049'),
              link: this.language == 'zh-TC' ? 'https://docs.google.com/forms/d/e/1FAIpQLSep8jqJSbo9fvN5F1YLYwyWzKaSGc3G_y6vzFfikvQTLcGLIQ/viewform' : this.language == 'ko' ? 'https://docs.google.com/forms/d/e/1FAIpQLSe-v5-CgXpFudeOf8jX_mtsQlXCez41e3AOvT-p8zFo64gY7g/viewform' : 'https://docs.google.com/forms/d/e/1FAIpQLSd0zIRGvBWB2Bv_fmiwqSMTx5vAcaPi7n443Jjj49UG8j-kOg/viewform',
              url: ""
            },
            {
              title: this.$t('400050'),
              link: "",
              url: `${urls.linkUrl}/userCenter/commission`
            },
            {
              title: "DAO",
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/articles/6736594090777-SuperEx%E5%85%A8%E7%90%83DAO%E6%8B%9B%E5%8B%9F' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/articles/6736567169689-SuperEx-%EA%B8%80%EB%A1%9C%EB%B2%8C-DAO-%ED%8C%8C%ED%8A%B8%EB%84%88-%EB%AA%A8%EC%A7%91' : 'https://support.superex.com/hc/en-001/articles/6736531883033-SuperEx-Global-DAO-Recruitment',
              url: ""
            },
            {
              title: this.$t('400291'), //ET专区
              link: "",
              url: `${urls.linkUrl}/advanced/et`
            },
            {
              title: 'APIs',
              link: "",
              url: `${urls.linkUrl}/apiKeyHome`
            },
            {
              title: this.$t('8100013'), // 官方验证通道
              link: "",
              url: `${urls.linkUrl}/verification`,
            },
          ],
        },
        {
          title: this.$t('400051'),
          sub: [
            {
              title: this.$t('400052'),
              link: this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk' : this.language == 'ko' ? 'https://support.superex.com/hc/ko' : 'https://support.superex.com/hc/en-001',
            },
            {
              title: this.$t('8100000'),
              link: "",
              url: `${urls.linkUrl}/feedback`
            },
            {
              title: this.$t('400053'),
              link: "https://support.superex.com/hc/en-001/requests/new",
            },
            {
              title: this.$t('400054'),
              link: "mailto:business@superex.com",
            },
            {
              title: this.$t('400055'),
              link: "mailto:gbg@superex.com",
            },
          ],
        },
        {
          title: "SCS",
          sub: [
            {title: "SCS Chain", link: "https://scschain.com/"},
            {title: this.$t('400239'), link: "https://scschain.com/stayTuned.html#module-contact"},
            {title: this.$t('400240'), link: "https://testnetscan.scschain.com/"},
            {
              title: this.$t('400241'),
              link: "https://superexchain.github.io/?_gl=1*qwdy0*_ga*NDQ5OTYxNTE1LjE2OTc2ODU3MTk.*_ga_W94SCVN3FF*MTY5OTg1MzU5Ni4xMjMuMS4xNjk5ODY0ODI5LjYwLjAuMA.."
            },
          ],
        },
        {
          title: this.$t('300135'),
          sub: [
            {title: this.$t('400234'), link: "", url: `${urls.linkUrl}/dao`},
            {title: this.$t('400235'), link: "", url: `${urls.linkUrl}/roadmap`},
            {title: this.$t('400236'), link: "", url: `${urls.linkUrl}/userCenter/commission`},
            {title: this.$t('400245'), link: "", url: `${urls.linkUrl}/noviceGuide/sevenDay`},
          ],
        },
      ]
    }
  },
  created() {
    this.getLinksApi()
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    enter(el, done) {
      const panel = this.$refs.localSwitchPanel;
      if (!panel || typeof panel.show !== 'function') {
        if (typeof done === 'function') done();
        return;
      }
      panel.show().then(done).catch(() => {
        if (typeof done === 'function') done();
      });
    },
    leave(el, done) {
      const panel = this.$refs.localSwitchPanel;
      if (!panel || typeof panel.hide !== 'function') {
        if (typeof done === 'function') done();
        return;
      }
      panel.hide().then(done).catch(() => {
        if (typeof done === 'function') done();
      });
    },
    getLinksApi() {
      this.linksObj = {
        twitter: [],
        telegram: [],
        medium: [],
        INS: [],
        Discord: [],
        YouTube: [],
        Facebook: [],
        CMC: []
      }
      linksApi().then(res => {
        if (res.data) {
          res.data.forEach(v => {
            if (v.type == 1) {
              this.socialContactList[1].sub.push(v)
            } else if (v.type == 2) {
              this.socialContactList[0].sub.push(v)
            } else if (v.type == 3) {
              this.socialContactList[3].sub.push(v)
            } else if (v.type == 4) {
              this.socialContactList[2].sub.push(v)
            } else if (v.type == 5) {
              this.socialContactList[4].sub.push(v)
            } else if (v.type == 6) {
              this.socialContactList[5].sub.push(v)
            } else if (v.type == 7) {
              this.socialContactList[6].sub.push(v)
            } else if (v.type == 8) {
              this.socialContactList[7].sub.push(v)
            } else {
              return false
            }
          })
        }
      })
    },
    triggerShowSubGroup(type) {
      if (window.innerWidth > 992) return
      this.showSubGroup = type
    },
    onResize() {
      if (window.innerWidth > 992) {
        this.showSubGroup = ''
      }
    }
  }
}
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

.m-site-map {
  position: relative;
  z-index: 1;

  padding: var(--m-padding-top) 0 70px;
  .sitemap-width{
    width: 100%;
    padding: 0 280px;
  }
}

.social-group {
  position: relative;
  z-index: 10;

  gap: 13px;

  .social-item {
    position: relative;
    z-index: var(--g--z-index);

    &:hover {
      .item-inner {
        color: color(var(--font-color));
        background-color: color(var(--theme-color));
      }

      .group--sub {
        visibility: visible;

        pointer-events: initial;

        opacity: 1;
      }

      .group--sub-inner {
        transform: translateY(0);
      }
    }

    .item-inner {
      @include circle(38px);
      font-size: 22px;

      transition: var(--transition-theme-color);

      color: color(var(--font-color), 0.6);
    }

    .group--sub {
      position: absolute;
      top: 100%;
      left: 50%;

      visibility: hidden;

      padding-top: 15px;

      transition: var(--transition-theme-color);
      transform: translateX(-50%);
      pointer-events: none;

      opacity: 0;
      color: color(var(--font-color), 0.6);

      backdrop-filter: blur(8px);
    }

    .group--sub-inner {
      font-size: 13px;
      line-height: 1.4;

      width: 400px;
      padding: 20px 28px;

      transition: var(--transition-theme-color);
      transform: translateY(20px);

      border: 1px solid color(var(--font-color), 0.11);
      border-radius: 8px;
      background: color(var(--site-background-color), 0.8);

      gap: 2px 10px;

      &::after {
        @include square(14px);
        position: absolute;
        bottom: calc(100% - 6px);
        left: 50%;

        content: "";
        transform: translateX(-50%) rotate(45deg);

        border: 1px solid color(var(--font-color), 0.1);
        border-right-width: 0;
        border-bottom-width: 0;
        background: color(var(--site-background-color), 1);
      }

      .sub-item {
        @include ellipse(1);
        padding: 8px 0;
        color: color(var(--font-color), 0.6);

        transition: var(--transition-theme-color);

        &:hover {
          color: color(var(--font-color));
        }
      }
    }
  }
}

.site-map {
  position: relative;
  z-index: 1;

  margin-top: 57px;
  padding-top: 57px;

  transition: var(--transition-theme-color);

  border-top: 1px solid color(var(--font-color), 0.1);

  .group-body {
    font-size: 14px;
    font-weight: 400;
    line-height: 160%; /* 22.4px */
    color: color(var(--font-color), 0.6);
  }

  .group-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 160%; /* 25.6px */

    margin-bottom: 30px;

    letter-spacing: em(-0.32px, 16px);
  }

  .sub-group {
    gap: 18px;
  }

  .sub-item {
    color: color(var(--font-color), 0.6);

    &:hover {
      color: color(var(--font-color), 1);

      .text::after {
        width: 100%;
      }
    }

    .text {
      position: relative;
      transition: var(--transition-theme-color);

      &::after {
        position: absolute;
        bottom: -0.3em;
        left: 0;

        width: 0%;
        height: 2px;

        content: "";
        transition: var(--transition-theme-color);

        color: color(var(--font-color), 0.6);
      }
    }
  }
}

.drawer-group--sub {
  font-size: 13px;
  font-weight: 500;
  line-height: 140%; /* 36.4px */

  color: color(var(--font-color), 0.6);

  .group--sub-inner {
    gap: 2px;
  }

  .sub-item {
    padding: 10px 0;

    &:hover {
      color: #fff;
    }
  }
}
@include media-breakpoint-down(xxxl) {
  .m-site-map{
    .sitemap-width{
      width: 100%;
      padding: 0 140px;
    }
  }
}
@include media-breakpoint-down(xxl) {
  .m-site-map {
    .sitemap-width{
      width: 100%;
      padding: 0 140px;
    }
    .logo-img {
      height: 30px;
    }
  }
  .social-group {
    gap: 10px;
  }
  .social-item {
    .item-inner {
      @include circle(34px);
      font-size: 20px;
    }
  }
  .site-map {
    margin-top: 47px;
    padding-top: 47px;

    .group-body {
      font-size: 13px;
    }

    .group-title {
      font-size: 15px;

      margin-bottom: 24px;
    }

    .sub-group {
      gap: 12px;
    }
  }
}

@include media-breakpoint-down(lg) {
  .social-contact {
    flex-direction: column;

    align-items: flex-start;
    gap: 20px;
  }
  .social-group {
    gap: 10px;

    .social-item {
      .item-inner {
        --u-size: 32px;
      }

      .group--sub {
        display: none !important;
      }
    }
  }
  .site-map {
    display: grid;

    margin-top: 30px;
    padding-top: 36px;

    gap: 24px;

    grid-template-columns: repeat(2, minmax(0, 1fr));

    .group-title {
      margin-bottom: 18px;
    }

    .sub-group {
      gap: 8px;
    }
  }
}
</style>
